import React from 'react';

import TypeWorker  from 'components/Tvendo/Sale/QuotaBPartner/ReglaParametro/TypeWorker/List.js';

export default function () {
  return <TypeWorker  />;
}